import { useTranslation } from 'react-i18next'

import clsx from 'clsx'

import { getPassengersText } from 'entities/tour/libs/getPassengersText.ts'
import { getTourDate } from 'entities/tour/ui/special-tours/libs/getTourDate.ts'

import { SpecialTour } from 'shared/api/tours/search'
import { priceShow } from 'shared/lib/priceShow.ts'
import { AppIcon } from 'shared/ui/app-icon'
import { AllIcons } from 'shared/ui/app-icon/types.ts'
import { Badge } from 'shared/ui/badge'
import { ImageLazy } from 'shared/ui/image-lazy'
import { MBonusDiscount } from 'shared/ui/mbonus/mbonus-discount'

import s from './styles.module.scss'

interface Props {
  data?: SpecialTour
  onClick: () => void
}

export const SpecialToursCard = ({ data, onClick }: Props) => {
  const { t } = useTranslation()
  const titleText = `${data?.state?.name}, ${data?.hotel_name}`

  const dateText = getTourDate(data)
  const passengerCount = getPassengersText(data?.adult)

  return (
    <div
      className={s.container}
      onClick={onClick}
    >
      <ImageLazy
        alt="tour image"
        src={data?.image}
        className={s.toursImage}
      />

      <Badge
        color={'white'}
        className={clsx('semi-bold-11', s.badge)}
      >
        <AppIcon
          id={AllIcons.PLAIN_BOLD}
          width={10}
          height={10}
        />
        {t('tours_block.town_from', { town: data?.town_from?.name })}
      </Badge>

      <div className={s.hotToursInfo}>
        <div className={s.titles}>
          <p className={clsx('bold-14', s.hotToursTitle)}>{titleText}</p>

          <div className={clsx('medium-12', s.texts)}>
            <p className={s.title}>{dateText}</p>
            <p className={s.subtitle}>
              {t('tours_block.nights_and_flights', {
                nights: data?.nights,
                passengers: t(passengerCount),
              })}
            </p>
          </div>
        </div>

        <div className={s.price}>
          <div className={s.currentPrice}>
            <p className={clsx('extra-bold-14', s.som)}>
              {`${t('price_start', { price: priceShow(String(data?.price || 0)) })}`}{' '}
            </p>

            <p className={clsx('semi-bold-12', s.dollar)}>
              (~&#36;
              {priceShow(String(Math.ceil(Number(data?.price_usd || 0))))})
            </p>
          </div>

          <div className={s.tags}>
            <MBonusDiscount title={`${3}% ${t('mbonus_discount')}`} />

            {/*<MplusText*/}
            {/*  tranche={'3500'}*/}
            {/*  className={s.mplus}*/}
            {/*/>*/}
          </div>
        </div>
      </div>
    </div>
  )
}
